import Vue from 'vue';

export default {
  getList(params) {
    return Vue.axios.get('/rx/user/api/v1.0/service/extend-info/my', {params});
  },
  deleteItem(params) {
    return Vue.axios.delete('/rx/user//api/v1.0/service/extend-info', { params });
  }
};
